import { Component } from '@angular/core';
import { AppInsightsLogginService } from './logging.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(private appInsightsLoggingService: AppInsightsLogginService) {

  }

  title = 'Seasonal Connect';
}
